import React from 'react';
import ImportProcedureLookup from "../../FileGroupingFileSpecImportProcedures/Models/Lookups/ImportProcedureLookup";
import { CatalogueEntry } from "../CatologueEntry";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"
import DataCache from "../../StaticData/StaticDataCache";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";
import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { Catalogue } from '@singularsystems/neo-react-services';

export default class ImportProceureCatalogueEntry extends CatalogueEntry<ImportProcedureLookup> {

    constructor() {
        super("Import Procedure", ImportProcedureLookup)
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.importProcedures;
    }

    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveImportProceduresList;
    }

    public renderRow(item: ImportProcedureLookup, meta: Model.TransformMetaType<ImportProcedureLookup>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.storedProcedure} />
                <NeoGrid.Column bind={meta.normaliseInd} />
                <NeoGrid.Column bind={meta.extractionInd} />
                <NeoGrid.Column bind={meta.dataInterceptionInd} />
                <NeoGrid.Column bind={meta.priority} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}